import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import Progress from "../../Progress";

class Mtb extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			infoText: this.props.t('Info_Select'),
			infoImg: '/img/silhouette/mtb_1.png',
			sadleheight: this.props.sadleheight,
			setback: this.props.setback,
			length: this.props.mtbLength,
			steerground: this.props.steerground,
			sadleground: this.props.sadleground,
			suspension: this.props.mtbSuspension,
			fully: this.props.fully,
		};


		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
		this.skip = this.skip.bind(this);
		this.selectInput = this.selectInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);


	}

	render() {

		var self = this;
		var radioFully = function () {
			if (self.state.fully === 'yes') {
				return (
					<div>
						<div className="radio-container">
							<input type="radio" id="fullyYes" name="fully" value="yes" checked onClick={self.selectInput} onChange={self.handleChange} />
							<label htmlFor="fullyYes">{self.props.t('Ja')}</label>
						</div>
						<div className="radio-container">
							<input type="radio" id="fullyNo" name="fully" value="no" onClick={self.selectInput} onChange={self.handleChange} />
							<label htmlFor="FullyNo">{self.props.t('Nee')}</label>
						</div>
					</div>
				)
			} else if (self.state.fully === 'no') {
				return (
					<div>
						<div className="radio-container">
							<input type="radio" id="fullyYes" name="fully" value="yes" onClick={self.selectInput} onChange={self.handleChange} />
							<label htmlFor="fullyYes">{self.props.t('Ja')}</label>
						</div>
						<div className="radio-container">
							<input type="radio" id="fullyNo" name="fully" value="no" checked onClick={self.selectInput} onChange={self.handleChange} />
							<label htmlFor="FullyNo">{self.props.t('Nee')}</label>
						</div>
					</div>
				)
			} else {
				return (
					<div>
						<div className="radio-container">
							<input type="radio" id="fullyYes" name="fully" value="yes" onClick={self.selectInput} onChange={self.handleChange} />
							<label htmlFor="fullyYes">{self.props.t('Ja')}</label>
						</div>
						<div className="radio-container">
							<input type="radio" id="fullyNo" name="fully" value="no" onClick={self.selectInput} onChange={self.handleChange} />
							<label htmlFor="FullyNo">{self.props.t('Nee')}</label>
						</div>
					</div>
				)
			}
		}


		return (
			<div className="container main">
				<Progress t={this.props.t} goTo={this.props.goTo} step={2} traject={this.props.traject} />
				<form className="row sizes mtb" onSubmit={this.handleSubmit}>
					<div className="col-12 text-center title">
						<h2>{this.props.t('Mountainbike maten')}</h2>
						<span className="sub-title">{this.props.t('SizesMtb-Framefit geeft')}</span>
					</div>
					<div className="col-lg-6 text-center">
						<img className="img-responsive" src={this.state.infoImg} alt="mtb maten" />
						<p className="info-mtb-sizes">{this.state.infoText}</p>
					</div>

					<div className="col-lg-6">
						<label className="mtbLabel">{this.props.t('Zadelhoogte')}</label>
						<div className="input-group mb-3">
							<input id="sadleheight" className="form-control" name="sadleheight" type="number" min="50" max="100" step="0.1" value={this.state.sadleheight} onClick={this.selectInput} onChange={this.handleChange} />
							<div className="input-group-append">
								<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
							</div>
						</div>
						<label className="mtbLabel">{this.props.t('Zadel setback')}</label>
						<div className="input-group mb-3">
							<input id="setback" className="form-control" name="setback" type="number" min="1" max="15" step="0.1" value={this.state.setback} onClick={this.selectInput} onChange={this.handleChange} />
							<div className="input-group-append">
								<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
							</div>
						</div>
						<label className="mtbLabel">{this.props.t('Zit lengte')}</label>
						<div className="input-group mb-3">
							<input id="length" className="form-control" name="length" type="number" min="40" max="100" step="0.1" value={this.state.length} onClick={this.selectInput} onChange={this.handleChange} />
							<div className="input-group-append">
								<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
							</div>
						</div>
						<label className="mtbLabel">{this.props.t('Zadel-grond')}</label>
						<div className="input-group mb-3">
							<input id="sadleground" className="form-control" name="sadleground" min="70" max="130" type="number" step="0.1" value={this.state.sadleground} onClick={this.selectInput} onChange={this.handleChange} />
							<div className="input-group-append">
								<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
							</div>
						</div>
						<label className="mtbLabel">{this.props.t('Stuur-grond')}</label>
						<div className="input-group mb-3">
							<input id="steerground" className="form-control" name="steerground" min="70" max="130" type="number" step="0.1" value={this.state.steerground} onClick={this.selectInput} onChange={this.handleChange} />
							<div className="input-group-append">
								<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
							</div>
						</div>
						<label className="mtbLabel">{this.props.t('Veerweg voor')}</label>
						<div className="input-group mb-3">
							<input id="suspension" className="form-control" name="suspension" type="number" min="0" max="25" step="0.1" value={this.state.suspension} onClick={this.selectInput} onChange={this.handleChange} />
							<div className="input-group-append">
								<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
							</div>
						</div>
						<label className="mtbLabel">{this.props.t('Achtervering')}</label>
						{radioFully()}
					</div>

					<div className="col-6 text-left">
						<button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
					</div>
					<div className="col-6 text-right">
						<a id="skipbtn" className="btn btn-secondary" onClick={this.skip}>{this.props.t('Sla over')}</a>
						<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
					</div>
				</form>



			</div>
		);

	}



	selectInput(event) {
		var input = event.target.id;
		var infoText = '';
		var infoImg = '/img/silhouette/mtb_1.png';
		if (input === 'sadleheight') {
			infoText = this.props.t('Info_Zadelhoogte');
			infoImg = '/img/silhouette/mtb_2.png';
		} else if (input === 'setback') {
			infoText = this.props.t("Info_ZadelSetback");
			infoImg = '/img/silhouette/mtb_3.png';
		} else if (input === 'length') {
			infoText = this.props.t('Info_Zitlengte');
			infoImg = '/img/silhouette/mtb_4.png';
		} else if (input === 'sadleground') {
			infoText = this.props.t('Info_ZadelGrond');
			infoImg = '/img/silhouette/mtb_5.png';
		} else if (input === 'steerground') {
			infoText = this.props.t('Info_StuurGrond');
			infoImg = '/img/silhouette/mtb_6.png';
		} else if (input === 'suspension') {
			infoText = this.props.t('Info_VeerwegVoor');
			infoImg = '/img/silhouette/mtb_7.png';
		} else if (input === 'fullyYes' || input === 'fullyNo') {
			infoText = this.props.t('Info_Vering');
		}
		this.setState({ infoText: infoText });
		this.setState({ infoImg: infoImg });
	}
	handleChange(event) {
		var field = event.target.id;
		var val = event.target.value;
		if (field === 'sadleheight') {
			this.setState({ sadleheight: val });
		} else if (field === 'setback') {
			this.setState({ setback: val });
		} else if (field === 'length') {
			this.setState({ length: val });
		} else if (field === 'sadleground') {
			this.setState({ sadleground: val });
		} else if (field === 'steerground') {
			this.setState({ steerground: val });
		} else if (field === 'suspension') {
			this.setState({ suspension: val });
		} else if (field === 'fullyYes' || field === 'fullyNo') {
			this.setState({ fully: val });
		}
	}
	handleSubmit(event) {
		event.preventDefault();
		if (this.state.sadleheight && this.state.setback && this.state.length && this.state.sadleground && this.state.steerground && this.state.suspension && this.state.fully) {
			this.props.handler(this.state.sadleheight, this.state.setback, this.state.length, this.state.sadleground, this.state.steerground, this.state.suspension, this.state.fully)
				.then(() => this.props.goTo('/advice/price', this.props.traject));
		} else {
			alert(this.props.t('vul aub de MTB maten in'));
		}
	}
	goBack(event) {
		event.preventDefault();
		this.props.goTo('/advice/sizes', 'mtb');
	}
	skip() {
		this.props.goTo('/advice/price', 'mtb');
	}
}

export default withTranslation('sizesMtb')(Mtb);
